import React, {useState} from 'react';
import {connect} from "react-redux";
import ContactEditPostalAddressRow from "./components/contact-edit-postal-address-row";

function ContactEditPostalAddressRows (props) {

    const {findContactDetails} = props;

    let uniqId = 0;

    let defaultPostalAddresses = [{
        "id": "0",
        "city": "",
	    "neighborhood": "",
        "formattedAddress": "",
        "label": "",
        "postCode": "",
	    "street": "",
	    "countryCode": "",
	    "state": ""
    }];

    if(findContactDetails.phoneContactEntry.postalAddresses){
        defaultPostalAddresses = findContactDetails.phoneContactEntry.postalAddresses.map((item) => {
            uniqId++;
            return {
                ...item,
                id: uniqId.toString()
            }
        })
    }

    const [postalAddressRows, setPostalAddressRows] = useState(defaultPostalAddresses);

    const handleNewPostalAddressRow = () => {
        setPostalAddressRows([
            ...postalAddressRows,
            {
                "id": (parseInt(postalAddressRows[postalAddressRows.length - 1].id, 10) + 1).toString(),
                "city": "",
	            "neighborhood": "",
                "formattedAddress": "",
                "label": "",
                "postCode": "",
	            "street": "",
	            "countryCode": "",
	            "state": ""
            }
        ])
    };

    const handleDeletePostalAddressRow = (e) => {
        setPostalAddressRows(postalAddressRows.filter((postalAddressRow, index) => parseInt(e.currentTarget.dataset.index, 10) !== index));
    };

    return (
        <div className="contact-edit-postal-address-rows border-top py-3">
            {
                postalAddressRows.map((postalAddress, index) => (
                    <ContactEditPostalAddressRow
                        key={postalAddress.id}
                        postalAddress={postalAddress}
                        index={index}
                        newPostalAddressRow={handleNewPostalAddressRow}
                        deletePostalAddressRow={handleDeletePostalAddressRow}
                    />
                ))
            }
        </div>
    )

}

const mapStateToProps = (state) => {
    return {
        findContactDetails: state.contactDetailsReducer.findContactDetails,
    }
};

export default connect(mapStateToProps)(ContactEditPostalAddressRows);
